export default __webpack_public_path__ + "static/media/end-call-white.28b982f0.svg";